import { useAppContext } from "@context/app";
import { IOrderCheckCartOutput, IOrderGiftCartOutput } from "@types";
import { orderApi } from "gate";
import { useEffect } from "react";

function useCart() {
  const { cart, setUserCart } = useAppContext();

  useEffect(() => {
    updateCart();
  }, []);

  const preparingCart = () => {
    const checkCartValue: IOrderCheckCartOutput = { items: [] };
    const items = [...cart];

    for (const sku of items) {
      let map = new Array(sku.qty);
      const gift: IOrderGiftCartOutput[] = [];
      const digital_gift_ids: number[] | undefined = sku.digital_gift_ids;
      const registry_contribution_ids: number[] | undefined = sku.registry_contribution_ids;

      for (const [index] of map.entries()) {
        const target = sku.gifts[index] || {};
        const balloons = Array.isArray((target as any).balloons)
          ? (target as any).balloons
              .filter((b: any) => (Number(b?.count) || 0) > 0)
              .map((b: any) => ({ id: String(b.id), count: Number(b.count) }))
          : [];
        const giftItem: IOrderGiftCartOutput = {
          wrapping: target.wrapping?.id || null,
          card: target.card?.id
            ? {
                id: target.card.id,
                from: target.card.from || undefined,
                to: target.card.to || undefined,
                message: target.card.message || undefined,
              }
            : null,
          // Keep payload lean: only send balloon id + count.
          customtext: sku.customText ? sku.customText[index]?.text : "",
        };
        if (balloons.length) {
          giftItem.balloons = balloons;
        }
        gift.push(giftItem);
      }

      checkCartValue.items.push({
        id: parseInt(sku.id as any),
        count: sku.qty,
        gift,
        digital_gift_ids,
        registry_contribution_ids,
      });
    }

    return checkCartValue;
  };

  const updateCart = async () => {
    const preparedCart = preparingCart();
    if (preparedCart?.items?.length) {
      try {
        const res = await orderApi.checkCart(preparedCart).fetch();
        const _cart = [...cart];
        for (const sku of _cart) {
          const target = res.data.cart.find((s) => s.id === sku.id);
          if (target) {
            sku.skuName = target.sku.name;
            sku.productName = target.sku.product?.name ?? sku.productName;
          }
        }
        setUserCart(_cart);
      } catch (error) {}
    }
  };
  return { updateCart };
}

export default useCart;
